
import './index.less'
import React from 'react'
const te = ['flex-start', 'center', 'flex-end']
console.log(React)
export default function SuspensionCopy(props) {
  const cardStyle = props.ifon.ifon.card
  const src = props.ifon.ifon.cardStyle.card1.headPortrait.src ? props.ifon.ifon.cardStyle.card1.headPortrait.src : 'https://i.gtimg.cn/qzone/biz/gdt/promotion/pages/landingpage/pagemaker/images/tencent_logo.png'

  return (<div draggable='false' className={`suspension`} style={{
    opacity: 0.5,
    width: 375
  }}>

    <div draggable='false' className='suspension_seizeASeat' style={{
      paddingTop: props.ifon.ifon.paddingTop,
      paddingBottom: props.ifon.ifon.paddingBottom,
      paddingLeft: props.ifon.ifon.paddingLeft,
      paddingRight: props.ifon.ifon.paddingRight
    }}>

      {cardStyle === 0 && <div draggable='false' style={{
        width: '100%',
        display: 'flex',
        justifyContent: te[props.ifon.ifon.layout]
      }}>
        <div draggable='false' className='card' style={{
          width: props.ifon.ifon.width + '%',
          borderRadius: props.ifon.ifon.fillet,
          backgroundColor: props.ifon.ifon.cardBackColor1
        }}>
          <img draggable='false' src={src} className='card_img' />
          <div draggable='false' className='card_ifon'>
            <h3 className='ifon_title'>{props.ifon.ifon.cardStyle.card1.headPortrait.accountName ? props.ifon.ifon.cardStyle.card1.headPortrait.accountName : '腾讯'}</h3>
            <span className='ifon_tips'>{props.ifon.ifon.cardStyle.card1.headPortrait.accountDescription ? props.ifon.ifon.cardStyle.card1.headPortrait.accountDescription : '腾讯公司唯一官方账号'}</span>
          </div>
          <button className='card_button' style={{
            fontSize: props.ifon.ifon.fontSize,
            color: props.ifon.ifon.cardColor,
            backgroundColor: props.ifon.ifon.cardBackColor
          }}>{props.ifon.ifon.cardStyle.card1.text ? props.ifon.ifon.cardStyle.card1.text : '关注'}</button>
        </div>
      </div>}

      {cardStyle === 1 && <div className='button' style={{
        height: props.ifon.ifon.cardStyle.card2.height,
        width: props.ifon.ifon.width + '%',
        fontSize: props.ifon.ifon.fontSize,
        borderRadius: props.ifon.ifon.fillet,
        color: props.ifon.ifon.cardColor,
        backgroundColor: props.ifon.ifon.cardBackColor
      }}>
        {props.ifon.ifon.cardStyle.card2.text ? props.ifon.ifon.cardStyle.card2.text : '关注微信公众号'}
      </div>}

      {cardStyle === 2 && <div className='codeBox' >
        <span className='codeBox_span' style={{
          fontSize: props.ifon.ifon.cardStyle.card3.fontSize,
          color: props.ifon.ifon.cardStyle.card3.color
        }} >{props.ifon.ifon.cardStyle.card3.describe1 ? props.ifon.ifon.cardStyle.card3.describe1 : '长按保存二维码到相册 关注获取更多内容'}</span>
        <div className='code'>
          <img draggable='false' className='code_img' src='https://read.e.qq.com/assets/images/yuebao/wxAttentionQrCodeDefault.png' />
        </div>
        <span className='codeBox_span' style={{
          fontSize: props.ifon.ifon.cardStyle.card3.fontSize,
          color: props.ifon.ifon.cardStyle.card3.color
        }}>公众号名称</span>
      </div>}

      {cardStyle === 3 && <div className='imgBox'>
        <img draggable='false' className='imgBox_img' src={props.ifon.ifon.cardStyle.card4.backImage.src ? props.ifon.ifon.cardStyle.card4.backImage.src : 'https://i.gtimg.cn/qzone/biz/gdt/promotion/pages/landingpage/pagemaker/images/wxAttentionHolder.png'} />
      </div>}

      {cardStyle !== 2 && props.ifon.ifon.isGuide && <div className='guideLayer'>
        <img draggable='false' className='guideLayer_img' src='https://read.e.qq.com/assets/images/yuebao/guide-1.png' />
      </div>}

    </div>
  </div >)
}
